import { CardPaymentDetailsIntl, PaymentExtraDetailsIntl } from 'types/i18n';

export const cardPaymentDetailsIntl: CardPaymentDetailsIntl = {
  titleText(id: number) {
    return `Платеж №${id}`;
  },
  detailsTable: {
    titleText: 'Описание',

    recievedAmountLabel: 'Поступило',
    creditedAmountLabel: 'На баланс',
    exchangeRateLabel: 'Курс обмена',
    statusLabel: 'Статус',
    orderIdLabel: 'Номер заказа',
    descriptionLabel: 'Описание',
    createdAtLabel: 'Дата создания',
    updatedAtLabel: 'Обновление',
    idLabel: 'ID платежа',
  },
  clientsTable: {
    titleText: 'Клиент',

    organizationLabel: 'Организация',
    fullNameLabel: 'ФИО',
  },
};

export const paymentExtraDetailsIntl: PaymentExtraDetailsIntl = {
  paymentTitle(id: number) {
    return `Платеж №${id}`;
  },
  descriptionTitle: 'Описание',
  bepaidReportTitle: 'Отчет от bepaid',

  descriptionLabel: 'Описание',
  amountLabel: 'Cумма',
  statusLabel: 'Статус',

  amountValue: (amount: number) => `${amount} Br`,
};
